import { motion } from "framer-motion";
import { EASE } from "@/lib/motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "", testid }) => (
    <motion.div
        data-testid={testid}
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.8, delay, ease: EASE }}
    >
        {children}
    </motion.div>
);

export default Reveal;
